import { Controller } from "stimulus";

export default class ScrollRevealController extends Controller {
  connect() {
    if (this.hasTargetValue) {
      this.targetElement = document.querySelector(this.targetValue);
    } else {
      this.targetElement = window;
    }

    this.scroll = this.scroll.bind(this);
    this.targetElement.addEventListener("scroll", this.scroll);
    // A restored or reloaded page can open part-way down, before any scroll event fires.
    this.scroll();
  }

  disconnect() {
    this.targetElement.removeEventListener("scroll", this.scroll);
  }

  scroll() {
    const start = this.startValue;
    const end = this.endValue;
    const scrollY = this.targetElement === window ? window.scrollY : this.targetElement.scrollTop;
    let progress = Math.min(Math.max((scrollY - start) / (end - start), 0), 1);
    this.element.style.opacity = progress;
  }
}

ScrollRevealController.values = {
  start: Number,
  end: Number,
  target: String
}

